export const STUDENT = '';
export const TUTOR = 'tutors';
export const PARENT = 'parents';
export const SCHOOL = 'partners';
export const ACADEMY = 'academy';
export const ACCOUNT = 'account';
export const ACCOUNT_REFERRAL = 'account/referral';
export const PREMIUM = 'premium';
export const HELP = 'help';
export const LOGIN = 'login';
export const SIGNUP = 'signup';



// WEBPACK FOOTER //
// ./src/constants/landingRoutes.js